import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './theme/theme.service';
import { IconRegistryService } from './core/services/icon-registry.service';
import { SnackbarContainerComponent } from './shared/components/snackbar/snackbar-container.component';

@Component({
    selector: 'fk-root',
    standalone: true,
    imports: [RouterOutlet, SnackbarContainerComponent],
    template: `
        <router-outlet></router-outlet>
        <fk-snackbar-container></fk-snackbar-container>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
    private iconRegistryService = inject(IconRegistryService);

    constructor(private themeService: ThemeService) {
        this.themeService.initTheme();
        this.iconRegistryService.registerIcons();
    }
}
